import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'al-no-rows-overlay',
    templateUrl: './no-rows-overlay.component.html',
    styleUrls: ['./no-rows-overlay.component.scss'],
    imports: [TranslateModule],
    encapsulation: ViewEncapsulation.None
})
export class NoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  @Input() public message = '';

  public agInit({ i18nMessageKey }: INoRowsOverlayParams & { i18nMessageKey: string }): void {
    this.message = i18nMessageKey;
  }
}
